import { isLibraryLoadedForId } from "selectors/LibraryProperties";

const DEFAULT_ARRAY = [];
const DEFAULT_OBJECT = {};

export const isPredictiveScoringEnabled = (state) => {
	const advertiserData = state.advertiserDetails?.data || DEFAULT_OBJECT;
	const creativeTaxonomy = advertiserData.creativeTaxonomy || DEFAULT_OBJECT;
	return creativeTaxonomy.predictiveScoringEnabled === true;
};

export const getAdvertiserId = (state) => {
	return state.advertiserDetails?.data?.id ?? null;
};

export const getLibraryKpis = (state) => {
	return state.predictiveScoring?.libraryKpis || DEFAULT_ARRAY;
};

export const doStoredLibraryKpisBelongToLibrary = (state, libraryId) => {
	const storedForLibraryId = state.predictiveScoring?.libraryKpisLibraryId ?? null;

	if (storedForLibraryId === null) { return false; }
	if (libraryId === null || libraryId === undefined) { return false; }

	return String(storedForLibraryId) === String(libraryId);
};

export const doStoredAdvertiserDetailsBelongToLibrary = (state, libraryId) => {
	if (!isLibraryLoadedForId(state, libraryId)) { return false; }

	const libraryAdvertiserId = state.libraryProperties?.advertiser?.id ?? null;
	const loadedAdvertiserId = state.advertiserDetails?.data?.id ?? null;

	return libraryAdvertiserId === loadedAdvertiserId;
};

export const getAvailableKpis = (state) => {
	return state.predictiveScoring?.availableKpis || DEFAULT_ARRAY;
};

export const getPrimaryKpi = (state) => {
	const kpis = getLibraryKpis(state);
	return kpis.find(kpi => kpi.isPrimary) || null;
};

export const getScoresForGrid = (state) => {
	return state.predictiveScoring?.scores || DEFAULT_OBJECT;
};

export const getScoreForEntity = (state, entityId) => {
	const scores = getScoresForGrid(state);
	return scores[entityId] || null;
};

export const getScoreDetail = (state) => {
	return state.predictiveScoring?.scoreDetail || null;
};

export const isScoresLoading = (state) => {
	return state.predictiveScoring?.loading || false;
};
